module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0047.jpg?v=dc55cbea";